import type { TagVariant } from '../components/tag'

export const getIconVariantColor = (variant: TagVariant) => {
  switch (variant) {
    case 'success':
      return 'success'

    case 'warning':
      return 'warning'

    case 'error':
      return 'error'

    case 'highlight':
      return 'highlight'

    case 'default':
    default:
      return 'gray'
  }
}
